import { useEffect, useRef, useState } from 'react';
import { Modal, Box, ClickAwayListener } from '@mui/material';

import AssistantAvatar from '@core/assistant/Avatar';
import { useAssistant } from '@core/assistant/providers/Provider';
import {
  DefaultScreen,
  HowToScreen,
  ChatScreen,
  TeleportScreen,
  LanguageSettingsScreen,
} from '../Screens';
import { SCREENS } from '@core/assistant/interfaces';
import { useOverlayContext } from '@providers/OverlayProvider';
import { useMytaverseEvent } from '@core/dashboard/providers/MytaverseEventProvider';
import OVERLAYS from '@constants/overlays';

import { useStyles } from './styles';

const ANIMATION_DURATION_MS = 550;

const Dashboard = () => {
  const { isOverlayCurrentlyOpen } = useOverlayContext();
  const { isTeleportingToRoomByUnreal } = useMytaverseEvent() ?? {};
  const isDockLeftOverlayOpen = [
    OVERLAYS.PROFILE,
    OVERLAYS.ADMIN_TOOLS,
    OVERLAYS.CHAT,
    OVERLAYS.PARTICIPANTS,
    OVERLAYS.TOOLBOX,
    OVERLAYS.TOOL_ACTIONS,
    OVERLAYS.ACTIONS,
  ].some((overlay) => isOverlayCurrentlyOpen(overlay));

  const isShiftedLeft = isDockLeftOverlayOpen || isTeleportingToRoomByUnreal;
  const prevShiftedLeftRef = useRef(isShiftedLeft);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (prevShiftedLeftRef.current !== isShiftedLeft) {
      prevShiftedLeftRef.current = isShiftedLeft;
      setShouldAnimate(true);

      const t = setTimeout(
        () => setShouldAnimate(false),
        ANIMATION_DURATION_MS,
      );

      return () => clearTimeout(t);
    }
  }, [isShiftedLeft]);

  const { activeScreen, open, setOpen, linearScriptPlayerRef } = useAssistant();
  const classes = useStyles(isShiftedLeft, shouldAnimate);

  const handleClickAway = () => {
    if (document.querySelector('[role="listbox"]')) {
      return;
    }

    const playerState = linearScriptPlayerRef.current?.getCurrentState();

    if (playerState?.isRunning) {
      return;
    }

    setOpen(false);
  };

  const renderScreen = () => {
    switch (activeScreen) {
      case SCREENS.HOW_TO: {
        return <HowToScreen />;
      }
      case SCREENS.CHAT: {
        return <ChatScreen />;
      }
      case SCREENS.TELEPORT: {
        return <TeleportScreen />;
      }
      case SCREENS.SETTINGS: {
        return <LanguageSettingsScreen />;
      }
      default: {
        return <DefaultScreen />;
      }
    }
  };

  return (
    <Box>
      <Modal open={open} sx={classes.modal} BackdropComponent={() => null}>
        <Box sx={classes.box(activeScreen !== SCREENS.DEFAULT)}>
          {/*<ClickAwayListener onClickAway={handleClickAway}>*/}
          <Box>
            <AssistantAvatar />
            {renderScreen()}
          </Box>
          {/*</ClickAwayListener>*/}
        </Box>
      </Modal>
    </Box>
  );
};

export default Dashboard;
